import CodeMirror from "@uiw/react-codemirror";
import { python } from "@codemirror/lang-python";
import { oneDark } from "@codemirror/theme-one-dark";
import { Loader2, Play, AlertCircle } from "lucide-react";
import { Button } from "../ui/button";

const SETUP = {
  lineNumbers: true, highlightActiveLineGutter: true, highlightSpecialChars: true, foldGutter: true, drawSelection: true,
  dropCursor: true, allowMultipleSelections: true, indentOnInput: true, bracketMatching: true, closeBrackets: true,
  autocompletion: true, rectangularSelection: true, crosshairCursor: true, highlightActiveLine: true,
  highlightSelectionMatches: true, closeBracketsKeymap: true, defaultKeymap: true, searchKeymap: true, historyKeymap: true,
  foldKeymap: true, completionKeymap: true, lintKeymap: true,
};

// Admin question dialog: Python sample solution editor + "Test Solution" against the test cases
export function PythonSampleEditor({ label = "Sample Solution (Python)", value, onChange, onTest, validating, validationError, height = "200px" }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <label className="text-sm font-medium">{label}</label>
        <Button variant="outline" size="sm" onClick={onTest} disabled={validating} className="gap-1.5 h-7" data-testid="test-solution-btn">
          {validating ? <Loader2 className="w-3 h-3 animate-spin" /> : <Play className="w-3 h-3" />}
          Test Solution
        </Button>
      </div>
      <div className="rounded-lg overflow-hidden border border-border">
        <CodeMirror value={value || ""} height={height} extensions={[python()]} theme={oneDark} onChange={onChange} data-testid="question-sample-solution" basicSetup={SETUP} />
      </div>
      {validationError && (
        <div className="mt-2 p-3 bg-destructive/10 border border-destructive/20 rounded-lg">
          <div className="flex items-start gap-2 text-destructive">
            <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" />
            <pre className="text-xs whitespace-pre-wrap font-mono">{validationError}</pre>
          </div>
        </div>
      )}
    </div>
  );
}
